import { c as _c } from "react/compiler-runtime";
import i18n from 'i18next';
import { IconButton, Tooltip, useDialog } from 'platform/components';
import { suffixTestId, TestIdProps } from 'shared/web';
import { SharePresetDialog } from './components/SharePresetDialog/SharePresetDialog';
export function SharePresetButton(props) {
  const $ = _c(16);
  const [isOpen, onOpen, onClose] = useDialog(false);
  let t0;
  if ($[0] !== onOpen) {
    t0 = () => {
      onOpen();
    };
    $[0] = onOpen;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onClick = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = i18n.t("page.datagrid.labels.sharePresetDialogTitle");
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = i18n.t("page.datagrid.labels.sharePresetDialogTitle");
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props) {
    t3 = suffixTestId("sharePreset", props);
    $[4] = props;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onClick || $[7] !== t3) {
    t4 = <Tooltip label={t1}><IconButton icon="social/share" onClick={onClick} aria-label={t2} data-testid={t3} /></Tooltip>;
    $[6] = onClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== isOpen || $[10] !== onClose || $[11] !== props) {
    t5 = isOpen && <SharePresetDialog onClose={onClose} data-testid={suffixTestId("sharePreset", props)} />;
    $[9] = isOpen;
    $[10] = onClose;
    $[11] = props;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}